module.exports = __webpack_public_path__ + "cn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/cn.svg
// module id = 753
// module chunks = 0